import getters from "./getters";
import actions from "./actions";
import * as types from "./../action-types";
import { cloneDeep } from "lodash";

const initialState = () =>
  cloneDeep({
    list: [],
    simpleList: [],
    registries: [],
    thirdPartyDevices: [],
  });

const normalizeDevices = (devices) => {
  return devices.map((device) => {
    device.device_id =
      device.mac_address || device.hardware_id || device.doorbot_id;
    device.type = device.type || device.kind;
    device.kind = device.type;
    return device;
  });
};

const mutations = {
  [types.FETCH_DEVICE_REGISTRIES.SUCCESS](state, data) {
    state.registries = data.registries;
    state.thirdPartyDevices = data.third_party_devices;
  },
  [types.FETCH_DEVICE_REGISTRIES.ERROR](state, _error) {
    state.registries = [];
    state.thirdPartyDevices = [];
  },
  [types.FETCH_DEVICE_LIST.SUCCESS](state, list) {
    state.list = normalizeDevices(list);
  },
  [types.FETCH_DEVICE_LIST.SUCCESS](state, list) {
    state.list = normalizeDevices(list);
  },

  [types.FETCH_SIMPLE_DEVICE_LIST.SUCCESS](state, list) {
    state.simpleList = list;
  },
  [types.FETCH_SIMPLE_DEVICE_LIST.ERROR](state, error) {
    state.simpleList = [];
  },
  resetState(state) {
    Object.assign(state, initialState());
  },
};

// Add non asynchronous actions
Object.assign(actions, {});

export default {
  state: initialState(),
  mutations,
  getters,
  actions,
  namespaced: true,
};
